import { render, staticRenderFns } from "./settings-users.vue?vue&type=template&id=6ba4d743&"
import script from "./settings-users.vue?vue&type=script&lang=js&"
export * from "./settings-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports